"use client";
import { useEffect, useRef } from "react";

interface UseSectionHashOptions {
  threshold?: number;
  rootMargin?: string;
  hash?: string;
}

export const useSectionHash = (options: UseSectionHashOptions = {}) => {
  const { threshold = 0.3, rootMargin = "-10% 0px -10% 0px", hash } = options;
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          //   if (entry.isIntersecting) {
          //   }
          if (entry.isIntersecting && entry.intersectionRatio > threshold) {
            // Change URL hash when section comes into view
            entry.target.classList.add("animate-fade-in-up"); // todo
            const newHash = hash || `#${entry.target.id}`;
            if (window.location.hash !== newHash) {
              // Use history.pushState to avoid page jump
              window.history.pushState(null, "", newHash);
            }
          }
        });
      },
      { threshold: threshold || 0.1, rootMargin }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    const elements = sectionRef.current?.querySelectorAll(".animate-on-scroll");
    elements?.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, [threshold, rootMargin, hash]);

  //   useEffect(() => {
  //     const observer = new IntersectionObserver(
  //       (entries) => {
  //         entries.forEach((entry) => {});
  //       },
  //       { threshold: 0.1 }
  //     );
  //     return () => observer.disconnect();
  //   }, []);

  return sectionRef;
};
